import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { backgroundDives } from "@/mocks/homeData";

export default function Background() {
  return (
    <section id="background" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1180px] px-4 py-14 md:px-6 md:py-20">
        <Reveal>
          <SectionHeading
            eyebrow="BACKGROUND DIG"
            title="身份背景深挖：能查的查到底，查不到的留白"
            description="从基本信息、时间线到动机推测分三层展开。每一层都写清楚依据和边界，避免把猜测当成结论。"
          />
        </Reveal>

        <div className="mt-12 flex flex-col gap-12 md:gap-16">
          {backgroundDives.map((item, index) => {
            const reversed = index % 2 === 1;
            return (
              <Reveal key={item.id} delay={index * 80}>
                <article className="grid grid-cols-1 items-center gap-6 md:gap-10 lg:grid-cols-2">
                  <div
                    className={`h-[240px] w-full overflow-hidden rounded-lg border border-background-200 md:h-[320px] ${
                      reversed ? "lg:order-2" : "lg:order-1"
                    }`}
                  >
                    <img
                      src={item.image}
                      alt={`海角黑料身份背景梳理示意图像 ${item.title}`}
                      title={`海角黑料人物背景 ${item.title}`}
                      className="h-full w-full object-cover object-top"
                    />
                  </div>

                  <div className={reversed ? "lg:order-1" : "lg:order-2"}>
                    <span className="font-label text-xs tracking-[0.2em] text-secondary-600">
                      LAYER {String(index + 1).padStart(2, "0")}
                    </span>
                    <h4 className="mt-3 font-heading text-xl font-bold leading-snug text-foreground-950 md:text-2xl">
                      {item.title}
                    </h4>
                    <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
                      {item.summary}
                    </p>
                    <ul className="mt-5 flex flex-col gap-2.5">
                      {item.points.map((point) => (
                        <li key={point} className="flex items-center gap-2.5 font-label text-sm text-foreground-800">
                          <span className="flex h-5 w-5 flex-none items-center justify-center rounded-full bg-primary-100 text-primary-700">
                            <i className="ri-check-line text-xs" />
                          </span>
                          {point}
                        </li>
                      ))}
                    </ul>
                  </div>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}